<template>
  <span>

    <!-- This is the Educations Dropdown Button -->
    <div id="educations-text">
      <div v-if="user" @click="toggleDropdownOverlay">
        {{ $store.state.user.langEng ? "EDUCATIONS" : "UTBILDNINGAR" }}
      </div>
    </div>
    
    <div @click.stop="toggleDropdown" class="educations-display-overlay"></div>

    <!-- This is the educations dropdown div-->
    <div class="z-depth-2 white" id="educations-display">
      <div
        v-for="(klass, i) in klasses"
        :key="i + klass.id"
        align="left"
      >
        <a 
          v-if="!klass.inactive" 
          id="klass" 
          :href="'https://' + klass.slug + '.lms.nodehill.se'">{{ klass.slug }} - {{ klass.name }}
        </a>
      </div>
    </div>
  </span>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class EducationsDropdown extends Vue {
  get user() {
    return this.$store.state.user.loggedInUser;
  }

  get klasses() {
    return this.$store.state.klasses
  }

  toggleDropdownOverlay() {
    if(!this.$store.state.isMobile) return
    document.querySelector('.educations-display-overlay').style.setProperty('display', 'block')
  }

  toggleDropdown() {
    document
      .querySelector(".educations-display-overlay")
      .style.setProperty("display", "none");
  }
}
</script>

<style scoped lang="scss">
#educations-text {
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  color: white;
  text-shadow: 0px 0px 3px #000000;
}

#educations-display {
  display: none;
  position: fixed;
  right: 25px;
  min-width: 10vw;
  border-radius: 5px;
  background: #ffffff;
  border-radius: 0.4em;
  z-index: 1000;
  padding: 25px;
  overflow-y: scroll;
  overflow-x: hidden;
  text-overflow: ellipsis;
  height: 400px;
}

#educations-text:hover ~ #educations-display {
  display: block;
}

#educations-display:hover {
  display: block;
}

#klass {
  display: block;
  border-bottom: 1px solid #dfdfdf;
  padding: 3px;
  a {
    color: var(--light-text-color);
  }
}

#klass:hover {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  cursor: pointer;
}
</style>
